// 시공일지 고객 링크 액션(rpc) — input.token 은 주소의 토큰과 같아야 한다(서버가 맞춰 본다).
import { shareRpc } from "@/api/client";

export const addLogCommentByLink = (input: { token: string; log_id: string; body: string }) =>
  shareRpc("c", input.token, "addLogCommentByLink", input);
